// Libraries
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { ADefaultButton, AButtonBaseProps } from '../../common/buttons';

export interface ACancelButtonProps extends Omit<AButtonBaseProps, 'children'> {
    children?: ReactNode;
}

export default function ACancelButton(props: ACancelButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { children, ...actionButtonProps } = props;
    const children2 = children ? children : t('AnelmaGeneral:1009');

    return <ADefaultButton {...actionButtonProps} children={children2} />;
}
